export default __webpack_public_path__ + "static/media/hinh4.dafe65a2.png";